import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {DataService} from "../../services/data.service";
import {ServerResponse} from "../../models/server-response.model";
import {Router} from '@angular/router';
import {Route} from '../../utils/constant';
import swal from 'sweetalert';

@Component({
  selector: 'app-btn-load-userrole-data',
  templateUrl: './btn-load-userrole-data.component.html',
  styleUrls: ['./btn-load-userrole-data.component.css']
})
export class BtnLoadUserRoleDataComponent implements OnInit {

  constructor(private userService: UserService, private dataService: DataService, private router: Router) {}

  ngOnInit() {}

  loadStaticUserRoles() {
    this.dataService.loadStaticUserRole().subscribe((response: ServerResponse) => {
      if (response.error === 0 && response.authError === 0) {
        swal({
          title: 'Message',
          text: 'UserRoles are loaded Successfully',
          icon: 'success'
        });
        this.router.navigate(['/' + Route.userrole]);
      } else{
        swal({
          title: 'Message',
          text: 'UserRoles are not loaded',
          icon: 'warning'
        });
      }
    });
  }

}
